import { createFileRoute } from "@tanstack/react-router";
import { Header, Footer } from "@/components/layout";
import { buildMeta } from "@/lib/seo";

export const Route = createFileRoute("/polityka-prywatnosci")({
  component: PrivacyPage,
  head: () => buildMeta({
    title: "Polityka prywatności | Tanie Latanie",
    description: "Polityka prywatności serwisu tanielatanie.pl — jakie dane zbieramy, w jakim celu i jakie masz prawa zgodnie z RODO.",
    path: "/polityka-prywatnosci",
  }),
});

function PrivacyPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <article className="container mx-auto max-w-3xl px-4 py-10 prose prose-invert">
        <h1 className="font-display text-4xl font-bold">Polityka prywatności</h1>
        <p className="text-muted-foreground">Ostatnia aktualizacja: {new Date().toLocaleDateString("pl-PL")}</p>

        <h2>1. Administrator danych</h2>
        <p>Administratorem danych osobowych jest właściciel serwisu tanielatanie.pl. W sprawach związanych z przetwarzaniem danych prosimy o kontakt na adres dostępny w zakładce Kontakt.</p>

        <h2>2. Zakres zbieranych danych</h2>
        <p>Zbieramy wyłącznie dane niezbędne do działania serwisu: zapytania wyszukiwania (lotniska, daty, liczba pasażerów), anonimowe dane analityczne (ścieżka, źródło ruchu, agent użytkownika) oraz — jeśli korzystasz z formularza kontaktowego — imię, e-mail i treść wiadomości.</p>

        <h2>3. Cel przetwarzania</h2>
        <p>Dane przetwarzamy w celu: realizacji wyszukiwania lotów, obsługi zapytań kontaktowych, analityki ruchu i poprawy jakości serwisu, oraz wypełnienia obowiązków prawnych.</p>

        <h2>4. Pliki cookies</h2>
        <p>Serwis używa plików cookies niezbędnych do działania oraz — za Twoją zgodą — cookies analitycznych. Ustawienia możesz w każdej chwili zmienić w sekcji „Ustawienia cookies” w stopce.</p>

        <h2>5. Twoje prawa</h2>
        <p>Masz prawo do dostępu do swoich danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia oraz wniesienia sprzeciwu i skargi do Prezesa UODO.</p>

        <h2>6. Partnerzy</h2>
        <p>Dane o lotach, dostępności miejsc oraz cenach biletów dostarcza i przetwarza:</p>
        <ul>
          <li><strong>eSky.pl S.A.</strong></li>
          <li>ul. Murckowska 14A, 40-265 Katowice</li>
          <li>NIP: 948-19-87-910</li>
          <li>REGON: 276826053</li>
          <li>KRS: 0000383663 (Sąd Rejonowy Katowice-Wschód w Katowicach, VIII Wydział Gospodarczy KRS)</li>
          <li>Kapitał zakładowy: 685 712,00 zł (opłacony w całości)</li>
        </ul>
        <p>Po kliknięciu „Sprawdź ceny biletów" możesz zostać przekierowany na stronę partnera (eSky lub innego biura podróży online), gdzie obowiązuje jego polityka prywatności i regulamin. Tanie Latanie nie jest stroną umowy zawieranej przez Ciebie z przewoźnikiem ani z biurem podróży.</p>
      </article>
      <Footer />
    </div>
  );
}
